import React, { useCallback } from 'react';

import CSRFContext from '@seccon/core/contexts/csrf';
import decodeJson from '@seccon/shared/utils/decodeJson';

const useUpdateSessionInfo = () => {
  const csrfToken = React.useContext(CSRFContext);

  return useCallback(async (sessionId, checked) => {
    const response = await fetch(
      `/personnelComparisonTool/${ sessionId }/verifyRecordsViewOnlyDiffs`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'anti-csrf-token': csrfToken
        },
        body: JSON.stringify({ value: checked })
      }
    );

    if (!response.ok) {
      console.error(`Network response was not ok: ${ response.status }`);
    }
    return decodeJson(response);
  }, [csrfToken]);
};

export default useUpdateSessionInfo;
